module.exports = __webpack_public_path__ + "static/media/1.2036764f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9024/1.jpg
// module id = 872
// module chunks = 0